import api from './api';
import store from "@/store"
import authHeader from './auth-header';

class AccountService {
    async getAccounts(accountGroupUuid) {
        return await api.get('/account/' + accountGroupUuid + '/accounts')
        .then(response => response.data)
    }

    async get() {
        let accountName = localStorage.getItem('account_name')
        if(accountName) {
            return await api.get('/account/by-sid/' + accountName).then(response => response.data)
        }
    }

    async createRoot(data) {
        return api.post('/account', data)
        .then(response => response.data);
    }

    async create(data, parentUuid) {
        return api.post('/account/parent/' + parentUuid, data)
        .then(response => response.data);
    }

    async modify(uuid, name) {
        return api.patch('/account/' + uuid, {
            name: name,
        })
        .then(response => response.data);
    }

    async getReasons(params = {}) {
        return api.get('/account/' + store.state.account.uuid + '/reason', {'params': params}, authHeader()).then(response => {
            //localStorage.setItem("reasons", JSON.stringify(response.data.reasons));
            return response.data
        });
    }

    async getPlaces(params = {}) {
        return api.get('/account/' + store.state.account.uuid + '/place', {'params': params}, authHeader()).then(response => {
            //localStorage.setItem("places", JSON.stringify(response.data.places));
            return response.data
        });
    }

    async getPersons(params = {}) {
        return api.get('/account/' + store.state.account.uuid + '/person', {'params': params}, authHeader()).then(response => {
            //localStorage.setItem("persons", JSON.stringify(response.data.persons));
            return response.data
        });
    }

    async getSetting(params = {}) {
        return api.get('/account/' + store.state.account.uuid + '/setting', {'params': params}, authHeader()).then(response => {
            //localStorage.setItem('setting', JSON.stringify(response.data))
            return response.data;
        });
    }

    async deactivate(uuid) {
        return api.patch('/account/' + uuid + '/deactivate')
        .then(response => response.data);
    }

    async activate(uuid) {
        return api.patch('/account/' + uuid + '/activate')
        .then(response => response.data);
    }

    async getDelegate(uuid) {
        return api.get('/account/' + uuid + '/delegate')
        .then(response => response.data)
    }

    async delegate(uuid, email, write) {
        return api.post('/account/' + uuid + '/delegate', {
            email: email,
            write: write
        })
        .then(response => response.data)
    }

    async modifyDelegate(accountUuid, userUuid, data) {
        return api.patch('/account/' + accountUuid + '/user/' + userUuid + '/delegate', data)
        .then(response => response.data)
    }

    async removeDelegate(accountUuid, userUuid) {
        return api.delete('/account/' + accountUuid + '/user/' + userUuid + '/delegate')
        .then(response => response.data)
    }
}

export default new AccountService();
  